import { supabase } from '../../../foundation/altzero_base/base/utils/supabaseClient';

/**
 * Check if a user has admin role
 */
export const isUserAdmin = async (userId: string): Promise<boolean> => {
  try {
    const { data, error } = await supabase
      .from('base_profiles')
      .select('role')
      .eq('id', userId)
      .single();

    if (error) {
      console.error('Error checking admin role:', error);
      return false;
    }

    return data?.role === 'admin';
  } catch (error) {
    console.error('Error checking admin role:', error);
    return false;
  }
};

/**
 * Validate that a user is admin, throw error if not
 */
export const validateAdminAccess = async (userId: string): Promise<void> => {
  const isAdmin = await isUserAdmin(userId);
  if (!isAdmin) {
    throw new Error('Admin access required');
  }
};
